<template>
  <div v-if="registrations.length > 0" ref="regCompleteForm">
    <v-layout wrap>
      <v-flex xs12>
        <div class="display-1">{{ $t('registration.steps[4]') }}</div>
      </v-flex>
      <v-spacer/>
      <v-flex xs12>
        <v-divider />
      </v-flex>
    </v-layout>
    <v-layout row wrap v-for="registration in registrations" :key="registration.id">
      <v-flex v-if="registration.status == 'registered'" xs12 pa-1 mt-1>
        <span class="subheading"><b>{{ registration.fname }} {{ registration.mname }} {{ registration.lname }}</b> </span>
        is now <b>registered</b> for the following event:
      </v-flex>
      <v-flex v-if="registration.status == 'waitlist'" xs12 pa-1 mt-1>
        <span class="subheading"><b>{{ registration.fname }} {{ registration.mname }} {{ registration.lname }}</b> </span>
        is now <b>waitlisted</b> for the following event:
      </v-flex>
      <v-flex xs12 px-3>
        <div class="title">
          {{ getEvent(registration['event-id']).name }}
        </div>
        <address>
          <span class="addr-name">{{ getRink(getEvent(registration['event-id'])['location-id']).name }}</span>
          <span class="addr-street">{{ getRink(getEvent(registration['event-id'])['location-id']).address }}</span>
          <span class="addr-area">{{ getRink(getEvent(registration['event-id'])['location-id']).city }} {{ getRink(getEvent(registration['event-id'])['location-id']).state }}, {{getRink(getEvent(registration['event-id'])['location-id']).zip }}</span>
        </address>
      </v-flex>
      <v-flex xs12 px-3 pt-1 class="font-weight-bold">
        {{ getEventDatetime(registration['event-id']) }}
      </v-flex>
    </v-layout>
    <v-layout wrap class="my-4">
      <v-flex xs12>
        <div style="font-size:24px">Transactions</div>
      </v-flex>
      <v-flex xs12>
        <v-layout v-for="detail in transaction.details" :key="detail.registration_id">
          <v-flex xs6>
            <small>{{ detail.label }} - {{ getEventFromRegId(detail.registration_id).name }}</small>
          </v-flex>
          <v-flex xs6 class="text-xs-right">
            <small>${{ parseFloat(detail.amount).toFixed(2) }}</small>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex xs12>
            <v-divider />
          </v-flex>
          <v-flex xs6>
          <span class="body-1">
            Transaction Id: {{ transaction['trans-id'] }}
          </span>
          </v-flex>
          <v-spacer />
          <v-flex xs6 align-content-end style="text-align: right;">
            Amount: ${{ transaction['total'] }}
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 pa-5>
        <p>Please check your email for your Registration Confirmation. If you do not receive a Confirmation, please contact us at: <a href="mailto:januszm@floridapanthers.com">januszm@floridapanthers.com</a> or call (954) 835-8358.</p>
        <p>Please print a copy of this page for your records.</p>
      </v-flex>
      <v-btn @click="print">Print</v-btn>
    </v-layout>
  </div>
</template>

<script>
import * as date from '../../libs/js/dates'
import { Printd } from 'printd'

export default {
  name: 'RegistrationComplete',
  data() {
    return {
      printCSS: [
        `address span {
          display: block;
          font-style: normal;
        } `,
        `v-btn {
          display: none;
        }`,
        `.title {
          font-size: 1.2rem;
        }`,
        `.display-1 {
          font-size: 2rem;
        }`,
        `.subheading {
          font-weight: bold;
        }`
      ]
    }
  },
  computed: {
    registrations () {
      return this.$store.state.registrations
    },
    transaction () {
      return this.$store.state.transaction
    },
    total () {
      if(this.registrations.length > 0) {
        let total = 0
        for(let i = 0; i < this.registrations.length; i++){
          if(this.registrations[i].status == 'pending' && this.getEvent(this.registrations[i]['event-id'])) {
            total += parseFloat(this.getEvent(this.registrations[i]['event-id']).total)
          }
        }
        return total
      }
      return 0
    },
    viewDate () {
      return (val, short) => date.viewDate(val, this.$i18n.locale, short)
    },
    viewDatetime() {
      return (val) => date.viewDatetime(val, this.$i18n.locale, this.rink.time_zone)
    },
    viewTime() {
      return (val) => date.viewTime(val, this.$i18n.locale, this.rink.time_zone)
    }
  },
  methods: {
    print() {
      const print = new Printd()
      print.print(this.$refs.regCompleteForm, this.printCSS)
    },
    getEventFromRegId(id) {
      let r = this.registrations.find(r => r.id.toString() === id.toString())
      let e = this.getEvent(r['event-id'])
      if(e) return e
      else return { name: '', description: '' }
    },
    getEvent(id){
      let e = this.$store.state.events.find(e => e.id.toString() === id.toString())
      if(e) return e
      else return { name: '', description: '' }
    },
    getEventDatetime(id){
      let e = this.$store.state.events.find(e => e.id.toString() === id.toString())
      if(e) return date.viewDatetime(e['event-datetime'], this.$i18n.locale)
      else return { name: '', description: '' }
    },
    getRink(id){
      let r = this.$store.state.rinks.find(e => e.id.toString() === id.toString())
      if(r) return r
      else return { name: '', description: '' }
    }
  }
}
</script>

<style scoped>
address span {
  display: block;
  font-style: normal;
}
</style>